import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function uid(prefix = ""): string {
  // 13-char base36 like "mo4kbi3jy7vbhn9" — timestamp + random
  const t = Date.now().toString(36);
  const r = Math.random().toString(36).slice(2, 9);
  return prefix + (t + r).slice(0, 15);
}

export function nowIso(): string {
  return new Date().toISOString();
}

export function safeNum(v: unknown, fallback = 0): number {
  const n = parseFloat(String(v ?? ""));
  return Number.isFinite(n) ? n : fallback;
}

export function clamp(n: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, n));
}

export function uniq<T>(arr: T[]): T[] {
  return Array.from(new Set(arr));
}
